import { render } from "./motors-edit.vue?vue&type=template&id=7da55614"
import script from "./motors-edit.vue?vue&type=script&lang=js"
export * from "./motors-edit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__